import classNames from 'classnames'
import { ErrorMessage, useField } from 'formik'
import { useRef } from 'react'

import type { InputHTMLAttributes, ReactElement, ChangeEvent } from 'react'

import VanillaTextInput from '../../Basic/TextInput'

import '../../input-common.scss'

export interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  componentClassName?: string
  disabled?: boolean
  focus?: boolean
  label?: string
  name: string
  placeholder?: string
  required?: boolean
  withErrorWrapper?: boolean
}

const TextInput = ({ componentClassName, focus, name, withErrorWrapper = true, ...props }: Props): ReactElement => {
  const ref = useRef<HTMLInputElement>(null)

  const [field, { error, touched, value }] = useField(name)

  const fieldContainerClasses = classNames('field-container', {
    erroneous: touched && error,
    valid: !error && !!value && !focus,
  })

  const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
    field.onChange(evt)
    props.onChange && props.onChange(evt)
  }

  return withErrorWrapper ? (
    <div className={classNames('input-component text-input-component input-container', componentClassName)}>
      <div className={fieldContainerClasses}>
        <VanillaTextInput
          autoFocus={focus}
          className="input-wrapper"
          ref={ref}
          {...field}
          {...props}
          onChange={handleChange}
        />
      </div>
      {touched && error ? <ErrorMessage className="error-message" component="span" name={name} /> : null}
    </div>
  ) : (
    <VanillaTextInput
      autoFocus={focus}
      className="input-wrapper"
      ref={ref}
      {...field}
      {...props}
      onChange={handleChange}
    />
  )
}

export default TextInput
